import React, { ReactElement } from 'react';
import { Skeleton, Stack, Typography } from '@mui/material';

interface StakingStatsItemProps {
  title: string;
  value: string | number;
  isLoading?: boolean;
}

export function StakingStatsItem({
  title,
  value,
  isLoading,
}: StakingStatsItemProps): ReactElement {
  return (
    <Stack spacing={1}>
      <Typography component="p" variant="h5">
        {isLoading ? <Skeleton width={30} /> : value}
      </Typography>

      <Typography
        component="p"
        sx={{
          fontSize: theme => theme.typography.pxToRem(12),
          color: theme => theme.palette.text.secondary,
        }}
      >
        {title}
      </Typography>
    </Stack>
  );
}
